<template>
  <tooltip :options="topTooltipOptions">
    <slot>
      <label class="form-label" :class="{ disable_field: disabled }">{{
        localeLabel
      }}</label>
    </slot>
  </tooltip>
</template>


<script>
 /* eslint-disable */ 
import Tooltip from "@credenceanalytics/tooltip";
export default {
  components: {
    Tooltip,
  },
  props: {
    label: {
      type: String,
      default: "",
    },
    placement: {
      type: String,
      default: "top",
    },
    disabled: {
      type: [String, Boolean, Object],
      default: false,
    },
  },
  computed: {
    topTooltipOptions() {
      return {
        content: this.localeLabel,
        placement: this.placement,
      };
    },
    localeLabel() {
      return this.$t(this.label.toLowerCase());
    },
  },
};
</script>